var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12","xs":"12","md":"12"}},[_c('Calendar',{attrs:{"is-widget":false,"status":_vm.status}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }